/* eslint-disable array-callback-return */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint-disable indent */
/* eslint-disable class-methods-use-this */
/* eslint-disable operator-linebreak */
/* eslint-disable no-plusplus */
/* eslint-disable quotes */
import { LitElement, html } from "lit-element";
import { HTMLChildrenMixin } from "../../kw-mixins/HTMLChildrenMixin";
import { kwCarouselStyles } from "./kw-carousel-style";

/**
 * `kw-carousel`
 * KwCarousel
 *
 * @customElement kw-carousel
 * @litElement
 * @demo demo/index.html
 */

export class KwCarousel extends HTMLChildrenMixin(LitElement) {
  static get is() {
    return "kw-carousel";
  }

  static get styles() {
    return [kwCarouselStyles];
  }

  static get properties() {
    return {
      /**
       * The items.
       * @type {Array}
       */
      items: { type: Array },

      /**
       * Flag whether the carousel can loop or not.
       * @type {boolean}
       */
      even: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.even = false;
    this._firstIndex = 0;
    this._offset = 0;
    this.studentsArray = [];
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("resize", this._initiateContainers);
    this.data = this._HTMLChildren();
    const itemsArray = Object.values(this.data[0]);
    itemsArray.map((element) => {
      const elementOneArray = this._getArrayData(element);
      const elementZero = this._getArrayData(elementOneArray[0]);
      const elementOne = this._getArrayData(elementOneArray[1]);
      const student = {
        url: elementZero[2],
        alt: elementZero[0],
        name: elementOne[0],
        title: elementOne[1],
        text: elementOne[2],
      };
      this.studentsArray.push(student);
    });
    this.even = this.studentsArray.length % 2 === 0;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this._initiateContainers);
  }

  render() {
    if (this.even) {
      return html`
        <div id="contents-even">
          <button
            class="btn-prev-even"
            @click=${() => this._move("left")}
          ></button>
          ${this.studentsArray.map(
            ({ url, name, title, text, alt }) => html`
              <article class="article-texts">
                <img src="${url}" alt="${alt}" />
                <p class="article-name">${name}</p>
                <p class="article-title">${title}</p>
                <p class="article-text">${text}</p>
              </article>
            `
          )}
          <button
            class="btn-next-even"
            @click=${() => this._move("right")}
          ></button>
        </div>
        <span class="border-mask">
          <span class="border-mask-top-left"></span>
          <span class="border-mask-top-right"></span>
        </span>
      `;
    }
    return html`
      <div id="contents">
        <button class="btn-prev" @click=${() => this._move("left")}></button>
        ${this.studentsArray.map(
          ({ url, name, title, text, alt }) => html`
            <article class="article-texts">
              <img src="${url}" alt="${alt}" />
              <p class="article-name">${name}</p>
              <p class="article-title">${title}</p>
              <p class="article-text">${text}</p>
            </article>
          `
        )}
        <button class="btn-next" @click=${() => this._move("right")}></button>
      </div>
      <span class="border-mask">
        <span class="border-mask-top-left"></span>
        <span class="border-mask-top-right"></span>
      </span>
    `;
  }

  _initiateContainers() {}

  _getArrayData(obj) {
    const objKeys = Object.keys(obj);
    const arrData = [];
    objKeys.forEach((objKey) => {
      arrData.push(obj[objKey]);
    });
    return arrData;
  }

  /**
   * Moves the items to the specified direction.
   * @param {string} direction The movement direction.
   */
  _move(direction) {
    if (direction === "left") {
      const lastStudent = this.studentsArray.splice(
        this.studentsArray.length - 1
      );
      this.studentsArray.unshift(lastStudent[0]);
    } else {
      const firstStudent = this.studentsArray.shift();
      this.studentsArray.push(firstStudent);
    }

    this.requestUpdate();
  }
}
